
import { useTranslation } from 'react-i18next';
interface VeoliaLogoProps {
  type: "short" | "long",
  onClick: any,
  companyLogo?: string | null
}

const VeoliaLogo: React.FC<VeoliaLogoProps> = ({ type = "long", onClick, companyLogo }) => {
  const { t } = useTranslation();
  const logoSrc = companyLogo || "/flxflow_logo.svg";

  return (
    <div className="flex items-center w-auto cursor-pointer" onClick={onClick}>
      {type === "short" ? (
        <img
          src={logoSrc}
          alt={t('Company Logo')}
          className="h-8 w-auto sm:h-10 md:h-12 cursor-pointer"
        />
      ) : (
        <img
          src={logoSrc}
          alt={t('Company Logo')}
          className="h-10 w-auto md:h-12 lg:h-14 cursor-pointer max-w-[120px] sm:max-w-[140px] md:max-w-[176px]"
        />
      )}
    </div>
  );
};

export default VeoliaLogo;
